import React, { Component,useRef } from 'react';
import ScrService from '../../../service/ScrService';
import { Column } from 'primereact/column';
import GenericGrid from '../../common/GenericGrid';
import { Dialog } from 'primereact/dialog';
import EntityLink from '../../common/EntityLink';

export class TestGrid extends Component{
	constructor(props) {
        super(props);
        //parentId
        //parentType
        //query
		//open
		//nav (if not open)
        console.log("TestGrid:props:"+JSON.stringify(props));
		this.setMenuItems();
        this.state={reload:true};
		//if(this.props.parentType == 'cls')
		//	this.orgId = this.props.cls.orgId;
		//else
			this.orgId = this.props.parentId;

    }
    componentDidUpdate=(prevProps,prevState)=>{
        console.log("TestGrid:componentDidUpdate");
        if(prevProps.query!=this.props.query||this.props.parentId!=prevProps.parentId||this.props.parentType!=prevProps.parentType)
		{
			console.log("TestGrid:reload->true");
			this.setState({reload:true});
		}
            
    }
	loadRecords = (parentId)=>{
		this.setState({reload:false});
		var ret;
		if(this.props.parentType == 'cls')
			ret= ScrService.getTestsByCls(parentId,this.props.query);
		else
			ret= ScrService.getTestsByOrg(parentId,this.props.query);
		return ret;
	}
	setMenuItems()
	{
		this.commandMenuItems = [
			{
			   label:'Publish tests',
			   action: 'publish'
			},
		 ];		
	}
	commandAction=(action,recs)=>{
	}
	openTestPage = (test)=>{
		if(this.props.nav)
        	this.props.nav('/test/'+test.id);
		else if(this.props.open)
			this.props.open(test);
    }
	render()
	{		
		var deleteMenu = false;
		if(this.props.deleteMenu != undefined)
			deleteMenu = this.props.deleteMenu;
		console.log('TestGrid:render');
		return (
			<>
			<GenericGrid dialogHeader="TEST" recType="Test" loadRecords={this.loadRecords} reload={this.state.reload}
					parentId={this.props.parentId} openPage={this.openTestPage}
					commandMenuItems={this.commandMenuItems} commandAction={this.commandAction}
					insertMenu deleteMenu={deleteMenu} exportMenu commandMenu filterMenu openButton> 
				<Column field="id" header="Id" style={{width:'5%'}} sortable body={this.idTemplate}></Column>
				<Column field="name" header="Name" style={{width:'30%'}} sortable></Column>
				<Column field="typeCode" header="Type" style={{width:'10%'}} sortable filter></Column>
				<Column field="testNo" header="Short name" style={{width:'10%'}} sortable></Column>
				<Column field="cat" header="Category" style={{width:'25%'}} sortable></Column>
				<Column field="status" header="Status" style={{width:'5%'}} sortable></Column>
				<Column field="testDate" header="Date" style={{width:'10%'}} sortable></Column>
			</GenericGrid>
			</>
		)
	}
	
}
export default TestGrid;
